import React, { useState, useEffect } from 'react';

const LoadingScreen = ({
  logo,
  fadeDuration = 1500,
  totalDuration = 2000,
  backgroundColor = 'bg-white',
  size = 'w-32 h-32',
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), fadeDuration);
    const removeTimer = setTimeout(() => setIsLoading(false), totalDuration);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, [fadeDuration, totalDuration]);

  if (!isLoading) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center ${backgroundColor} transition-opacity duration-500 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <img src={logo} alt="Logo" className={`${size} animate-pulse`} />
    </div>
  );
};

export default LoadingScreen;